import { render, staticRenderFns } from "./FaqsMain.vue?vue&type=template&id=55a35dcb&scoped=true&"
import script from "./FaqsMain.vue?vue&type=script&lang=js&"
export * from "./FaqsMain.vue?vue&type=script&lang=js&"
import style0 from "./FaqsMain.vue?vue&type=style&index=0&id=55a35dcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a35dcb",
  null
  
)

export default component.exports